// @flow
import { getCreator, postCreator } from '../../../../http';
import environment from '../../../../environment';

export const endpoints = Object.freeze({
  SET_TRACKING_NUMBER: `${environment.apiUrl}/sale/:orderId/:itemNumber/set-tracking-number`,
  CONFIRM_ITEM_RECEIVED: `${environment.apiUrl}/sale/:orderId/:itemNumber/confirm-item-received`,
  UNCONFIRM_ITEM_RECEIVED: `${environment.apiUrl}/sale/:orderId/:itemNumber/unconfirm-item-received`,
  PROGRESS_RECEIVE: `${environment.apiUrl}/sale/:orderId/progress/receive`,
  GET_CANCELATION_MOTIVES: `${environment.apiUrl}/meta/cancellation-motives`,
  CANCEL_PURCHASED_ITEM: `${environment.apiUrl}/sale/:orderId/:itemNumber/confirm-item-can-not-deliver`,
});

export const postSetTrackingNumberApi = postCreator(fetch, endpoints.SET_TRACKING_NUMBER);
export const postConfirmItemReceivedApi = postCreator(fetch, endpoints.CONFIRM_ITEM_RECEIVED);
export const postUnconfirmItemReceivedApi = postCreator(fetch, endpoints.UNCONFIRM_ITEM_RECEIVED);
export const postProgressReceive = postCreator(fetch, endpoints.PROGRESS_RECEIVE);
export const fetchCancellationMotivesApi = getCreator(fetch, endpoints.GET_CANCELATION_MOTIVES);
export const portCancelPurchasedItem = postCreator(fetch, endpoints.CANCEL_PURCHASED_ITEM);



// WEBPACK FOOTER //
// ./src/modules/order/Sale/purchased/api.js